module.exports = __webpack_public_path__ + "static/media/advertisers_m_1.be64343b.png";